package com.wintermar.inspection.core.ui.component.image

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.rememberTransformableState
import androidx.compose.foundation.gestures.transformable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import coil3.compose.AsyncImage
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.image.util.FileDownloader
import com.wintermar.inspection.core.ui.component.image.util.FileMimeType
import com.wintermar.inspection.core.ui.component.image.util.FileModel
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_close
import inspection.composeapp.generated.resources.ic_download
import kotlinx.coroutines.launch

@Composable
fun ImagePreviewDialog(
    file: FileModel,
    onDismiss: () -> Unit
) {
    val color = LocalAppTheme.current.color
    val dimension = LocalAppTheme.current.dimension

    var scale by remember { mutableFloatStateOf(1f) }
    var offset by remember { mutableStateOf(Offset.Zero) }

    val transformState = rememberTransformableState { zoomChange, panChange, _ ->
        scale = (scale * zoomChange).coerceIn(1f, 5f)
        offset = if (scale > 1f) offset + panChange else Offset.Zero
    }

    val scope = rememberCoroutineScope()

    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
            dismissOnBackPress = true,
            dismissOnClickOutside = true
        )
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.Black.copy(alpha = 0.9f))
                .clickable { onDismiss() },
            contentAlignment = Alignment.Center
        ) {
            AsyncImage(
                model = file.blob ?: file.path,
                contentDescription = file.name,
                modifier = Modifier
                    .fillMaxSize()
                    .graphicsLayer(
                        scaleX = scale,
                        scaleY = scale,
                        translationX = offset.x,
                        translationY = offset.y
                    )
                    .transformable(state = transformState)
                    .clickable(enabled = false) {}
            )

            Box(
                modifier = Modifier
                    .align(Alignment.TopStart)
                    .padding(dimension.spacing.space4)
            ) {
                IconButton(
                    icon = Res.drawable.ic_close,
                    backgroundColor = Color.Transparent,
                    tint = color.icon.inverse,
                    onClick = onDismiss
                )
            }

            Box(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .padding(dimension.spacing.space4)
            ) {
                IconButton(
                    icon = Res.drawable.ic_download,
                    backgroundColor = Color.Transparent,
                    tint = color.icon.inverse,
                    onClick = { scope.launch { FileDownloader.download(file, FileMimeType.IMAGE) } }
                )
            }
        }
    }
}
